import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// ---------------------------------------------------------

import Card from '@components/card';
import Container from '@layout/container';
import Listing from '@lib/models/listing';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const { card, container, header, card_wrapper, left_align } = styles;

// ---------------------------------------------------------

const SimilarProperties = (props) => {
  const { properties: listings, address } = props;

  // -------------------------------------------------------

  const header_classes = classNames(header, {
    [left_align]: listings.length < 3
  });

  return (
    <Container className={container} gridOptions={{ layout: 'single' }} spacing="small">
      <h2 className={header_classes}>
        {address ? `Properties Similar to ${address}` : 'Similar Properties'}
      </h2>
      <div className={card_wrapper}>
        {listings.map((listing) => {
          return (
            <Card
              {...listing}
              url={Listing.canonicalize(
                `/listing/${listing.property.listingId}/${listing.property.address}-${listing.property.city}-${listing.property.state}-${listing.property.zip}`
              )}
              key={listing.property.listingId}
              className={card}
              smallVersion
            />
          );
        })}
      </div>
    </Container>
  );
};

SimilarProperties.propTypes = {
  /**
   * Specifies the similar properties data
   */
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Specifies the image src and alt text
       */
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

      listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

      /**
       * Specifies the details of a property
       */
      property: PropTypes.shape({
        address: PropTypes.string,
        alertPills: PropTypes.array,
        alerts: PropTypes.array,
        city: PropTypes.string,
        details: PropTypes.arrayOf(
          PropTypes.shape({
            ac: PropTypes.number,
            ba: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            br: PropTypes.number
          })
        ),
        price: PropTypes.string,
        realtor: PropTypes.shape({
          isActiveSibcyAgent: PropTypes.bool,
          name: PropTypes.string,
          url: PropTypes.string
        }),
        state: PropTypes.string,
        zip: PropTypes.string
      }),

      /**
       * Specifies the url if the whole card is clickable
       */
      url: PropTypes.string
    })
  ),
  address: PropTypes.string
};

export default SimilarProperties;
